import React from "react"
import styled from "styled-components"
import { theme } from "@/common/Mixin"
import NextImg from "@/common/components/NextImg/index"
import top from "@/common/assets/image/Mainpage/hi/Top.svg"

const Fade = require("react-reveal/Fade")

export interface DescriptionProps {
  videoUrl: string
}

export default function VideoSection({ videoUrl }: DescriptionProps) {
  return (
    <Wrapper>
      <TopWrapper>
        <NextImg src={top} />
      </TopWrapper>
      <ContentWrapper className="kg-wrapper">
        <Fade bottom>
          <iframe
            width="100%"
            style={{ aspectRatio: "560 / 315" }}
            src={videoUrl}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </Fade>
      </ContentWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: ${theme.color.secondary};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const ContentWrapper = styled.div`
  display: flex;
  padding-top: 3vh;
  padding-bottom: 5vh;
  justify-content: center;
  align-items: center;
  width: 100%;

  @media (${theme.lg}) {
    flex-direction: column;
    gap: 48px;
  }
`

const TopWrapper = styled.div`
  margin-bottom: 3vh;
  width: 100%;
  transform: translateY(-1px);
  @media (${theme.lg}) {
    margin-bottom: 0vh;
  }
`
